import {Component, Input, OnInit} from '@angular/core';
import {Direction} from '@angular/cdk/bidi';

@Component({
  selector: 'app-text-icon-box',
  templateUrl: './text-icon-box.component.html',
  styleUrls: ['./text-icon-box.component.scss']
})
export class TextIconBoxComponent implements OnInit {

  @Input() text: string;
  @Input() icon: string;
  @Input() value: string;
  @Input() dir: Direction = 'rtl';
  @Input() link: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
